/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */

import React, { useContext, useState } from 'react';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { dataService } from '../../../../../services/data.services';
import PreviewPayslip from '../PreviewPayslip';
import TextSection from '../../../../../components/ToolTip/TextSection';

const TableBody = ({
    tableData, 
    indexNum, 
    branch_data,
}) => {  
    const {setToastErrorMessage, setToastmessage} = useContext(GlobalContext);
    const [isPreview, setIsPreview] = useState(false);
    const [hover, sethover] = useState('')
    const [hoverIndex, sethoverIndex] = useState(null)
    const [loadingDownload, setLoadingDownload] = useState(false);

    /**
     * The function `handleDownload` is an asynchronous function that handles the download of a payslip
     * by sending a POST request to the server and opening the resulting pre-signed URL in a new tab.
     */
    const handleDownload = async() => {
        setLoadingDownload(true)
        try {
            const payload = {
                "branch_id": tableData.branch_id,
                "employee_id": tableData.employee_id,
                "employee_name": tableData.employee_name,
                "financial_year": tableData.financial_year,
                "month": tableData.month
            }
            const res = await dataService.PostAPI(payload,'payroll/download');
            window.open(res.data.data.pre_signed_url, '_blank');
            // getStudentsDirectory()
            setToastmessage("Payslip downloaded successfully");
        } catch (error) {
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
        setLoadingDownload(false)
    }
    return (
        <>
            <AnimatedList
                rowStatus={true}
                keyItem={indexNum}
                handleClick={()=>{}}
                child={
                    <>
                        <td class="pl-[35px] px-3 py-3 text-f2 font-normal text-[#031624] whitespace-nowrap ">{tableData?.month || "-"}</td>
                        <td class="px-3 pb-2 ">
                            <div className='flex'>
                                <>
                                    <div className='relative group pb-3 pt-3.5'>
                                        <div className='relative top-[55px] z-10 -left-[22px] scale-0 group-hover:scale-100'>
                                            <TextSection text='Preview' show from={'academicreports'} />
                                        </div>
                                    
                                        <button
                                            id='view'
                                            class={`edit_value`}
                                            data-tooltip-target="panuploadInfo"
                                            data-tooltip-trigger="hover"
                                            data-tooltip-placement="top"
                                            type="button"
                                            onMouseEnter={()=>{sethover('preview'), sethoverIndex(indexNum)}} 
                                            onMouseLeave={()=>{sethover(''), sethoverIndex(null)}}
                                        >
                                            <img 
                                                src="/images/payroll-document-icon.svg" 
                                                alt="download" 
                                                className='mr-2 cursor-pointer'
                                                onClick={() => {setLoadingDownload(false); setIsPreview(true); }}
                                            />
                                        </button>
                                    </div>
                                                            
                                </>
                                <>
                                    <div className='relative group py-3'>
                                        <div className='relative  top-[57px]  z-10 -left-[22px] scale-0 group-hover:scale-100'>
                                            <TextSection text='Download' show from={'academicreports'} />
                                        </div>
                                        <button

                                            class={`edit_value`}
                                            data-tooltip-target="panuploadInfo"
                                            data-tooltip-trigger="hover"
                                            data-tooltip-placement="top"
                                            type="button"
                                            onMouseEnter={()=>{sethover('download'), sethoverIndex(indexNum)}} 
                                            onMouseLeave={()=>{sethover(''), sethoverIndex(null)}}
                                        >
                                            <img 
                                                src="/images/upload-cloud-svgrepo-com.svg" 
                                                id="Download"
                                                alt="download" 
                                                className='cursor-pointer'
                                                onClick={() => handleDownload()}
                                            />
                                        </button>
                                    </div>                    
                                </>
                                
                            </div>
                        </td>
                    </>
                    
                }/>
          
            
            
            {isPreview && 
            <PreviewPayslip 
                setIsPreview={setIsPreview}
                tableData={tableData}
                branch_data={branch_data}
                handleDownload={handleDownload}
                loadingDownload={loadingDownload}
            />}
        </>
        
    );
}

export default TableBody;
